module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container skszWrap"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "modtTitle"
  }, [_vm._v("重要说明")]), _vm._v(" "), _c('ul', {
    staticClass: "zysmUl"
  }, [_c('li', [_vm._v("1.本页面申请资料主要用于开通微信收款，收款功能由微信支付提供服务。")]), _vm._v(" "), _c('li', [_vm._v("2.本页面提交的资料要较多请先准备好所有资料文件后，再进行填写；")]), _vm._v(" "), _c('li', [_vm._v("3.申请过成中涉及到多次验证；请务必填写可配合验证人员信息。")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "modtTitle"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopName),
      expression: "shopName"
    }],
    staticClass: "dpmcRight"
  }, [_vm._v("企业名称：" + _vm._s(_vm.shopName) + " ")]), _vm._v("开通微信收款状态")]), _vm._v(" "), _c('dl', {
    staticClass: "ktwxskzt"
  }, [_c('dd', [_c('p', [_vm._v("当前状态："), _c('span', {
    staticClass: "dqzt"
  }, [_vm._v(_vm._s(_vm.currentState))])]), _vm._v(" "), _c('p', [_vm._v("阶段描述："), _c('span', [_vm._v(_vm._s(_vm.describe))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applymentState == 'ACCOUNT_NEED_VERIFY'),
      expression: "applymentState == 'ACCOUNT_NEED_VERIFY'"
    }]
  }, [_vm._v("打款验证："), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.seePaymentInfo()
      }
    }
  }, [_vm._v("查看打款信息")])], 1)]), _vm._v(" "), _c('dt', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applymentState == 'NEED_SIGN'),
      expression: "applymentState == 'NEED_SIGN'"
    }],
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.signUrl
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applymentState == 'ACCOUNT_NEED_VERIFY'),
      expression: "applymentState == 'ACCOUNT_NEED_VERIFY'"
    }],
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.legalUrl
    }
  })])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "modtTitle"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("主体类型 :")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.ztlx),
      callback: function($$v) {
        _vm.ztlx = $$v
      },
      expression: "ztlx"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("个体工商户")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "yyzzDiv"
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("营业执照 :")]), _vm._v(" "), (_vm.yyzzLong) ? _c('el-image', {
    staticClass: "yyzzAvatarImg",
    attrs: {
      "src": _vm.yyzzLong,
      "preview-src-list": [_vm.yyzzLong]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 1); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus yyzzUploader"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit && _vm.yyzzLong),
      expression: "isEdit && yyzzLong"
    }],
    staticClass: "yyzzDel",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(1)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "yyzzSM"
  }, [_vm._v(" 营业执照支持jpg、png格式、不超过2MB。 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "yyzzRight"
  }, [_c('el-input', {
    staticClass: "singleRow whiteDis",
    staticStyle: {
      "width": "83%"
    },
    attrs: {
      "placeholder": "请输入企业名称",
      "maxlength": "30",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.qymc),
      callback: function($$v) {
        _vm.qymc = $$v
      },
      expression: "qymc"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("企业名称 :")])], 2), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    staticStyle: {
      "width": "83%"
    },
    attrs: {
      "placeholder": "请输入企业法人",
      "maxlength": "21",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.qyfr),
      callback: function($$v) {
        _vm.qyfr = $$v
      },
      expression: "qyfr"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("企业法人 :")])], 2), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    staticStyle: {
      "width": "83%"
    },
    attrs: {
      "placeholder": "请输入信用代码",
      "maxlength": "21",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.xydm),
      callback: function($$v) {
        _vm.xydm = $$v
      },
      expression: "xydm"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("信用代码 :")])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("有效期限 :")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "25%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.kssj),
      callback: function($$v) {
        _vm.kssj = $$v
      },
      expression: "kssj"
    }
  }), _vm._v(" 至\r\n          "), _c('el-date-picker', {
    staticStyle: {
      "width": "25%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期",
      "disabled": !_vm.isEdit || _vm.yxqxOne
    },
    model: {
      value: (_vm.jssj),
      callback: function($$v) {
        _vm.jssj = $$v
      },
      expression: "jssj"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.yxqxOne),
      callback: function($$v) {
        _vm.yxqxOne = $$v
      },
      expression: "yxqxOne"
    }
  }, [_vm._v("长期有效")])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "例如：大卫地板  （ 最多可输入21个字）",
      "maxlength": "21",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.withdrawerName),
      callback: function($$v) {
        _vm.withdrawerName = $$v
      },
      expression: "withdrawerName"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("商 户 简 称 :")])], 2), _vm._v(" "), _c('div', {
    staticClass: "rxgh"
  }, [_c('div', {
    staticClass: "rxghDiv"
  }, [(_vm.rxLong) ? _c('el-image', {
    staticClass: "rxghAvatarImg",
    attrs: {
      "src": _vm.rxLong,
      "preview-src-list": [_vm.rxLong]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 2); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus rxghUploader"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit && _vm.rxLong),
      expression: "isEdit && rxLong"
    }],
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(2)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rxghSM"
  }, [_vm._v(" 法人或经营者身份证正面（人像） ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rxghDiv"
  }, [(_vm.ghLong) ? _c('el-image', {
    staticClass: "rxghAvatarImg",
    attrs: {
      "src": _vm.ghLong,
      "preview-src-list": [_vm.ghLong]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 3); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus rxghUploader"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit && _vm.ghLong),
      expression: "isEdit && ghLong"
    }],
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(3)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rxghSM"
  }, [_vm._v(" 法人或经营者身份证反面（国徽） ")])], 1)]), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入身份证姓名",
      "maxlength": "21",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.sfzxm),
      callback: function($$v) {
        _vm.sfzxm = $$v
      },
      expression: "sfzxm"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("身份证姓名 :")])], 2), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入身份证号码",
      "maxlength": "21",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.sfzhm),
      callback: function($$v) {
        _vm.sfzhm = $$v
      },
      expression: "sfzhm"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("身份证号码 :")])], 2), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入居住地址",
      "maxlength": "200",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.jzdz),
      callback: function($$v) {
        _vm.jzdz = $$v
      },
      expression: "jzdz"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("居 住 地 址 :")])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("有 效 期 限 :")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "23%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.ksTime),
      callback: function($$v) {
        _vm.ksTime = $$v
      },
      expression: "ksTime"
    }
  }), _vm._v(" 至\r\n        "), _c('el-date-picker', {
    staticStyle: {
      "width": "23%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "disabled": !_vm.isEdit || _vm.yxqxTwo
    },
    model: {
      value: (_vm.jsTime),
      callback: function($$v) {
        _vm.jsTime = $$v
      },
      expression: "jsTime"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.yxqxTwo),
      callback: function($$v) {
        _vm.yxqxTwo = $$v
      },
      expression: "yxqxTwo"
    }
  }, [_vm._v("长期有效")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "modtTitle"
  }, [_vm._v("结算账户")]), _vm._v(" "), _c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("账户类型 :")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.zhlx),
      callback: function($$v) {
        _vm.zhlx = $$v
      },
      expression: "zhlx"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 74,
      "disabled": _vm.ztlx == 2
    }
  }, [_vm._v("对公账户")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ztlx == 4),
      expression: "ztlx == 4"
    }],
    attrs: {
      "label": 75
    }
  }, [_vm._v("对私账户")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("开户银行 :")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.choiceRange()
      }
    }
  }, [_vm._v("选择开户银行")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.kaihuBank))])], 1), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "公（企业名称）  /    私  法人(经营者)姓名",
      "maxlength": "15",
      "disabled": ""
    },
    model: {
      value: (_vm.kaihuName),
      callback: function($$v) {
        _vm.kaihuName = $$v
      },
      expression: "kaihuName"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("开户名称 :")])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("开户城市 :")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "33%"
    },
    attrs: {
      "placeholder": "请选择省份",
      "disabled": !_vm.isEdit
    },
    on: {
      "change": _vm.changeProvince
    },
    model: {
      value: (_vm.provinceId),
      callback: function($$v) {
        _vm.provinceId = $$v
      },
      expression: "provinceId"
    }
  }, _vm._l((_vm.tbdprovince), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.province_name,
        "value": item.province_code
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "33%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "disabled": !_vm.isEdit || !_vm.provinceId
    },
    on: {
      "change": _vm.changeCity
    },
    model: {
      value: (_vm.cityId),
      callback: function($$v) {
        _vm.cityId = $$v
      },
      expression: "cityId"
    }
  }, _vm._l((_vm.tbdcity), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.city_name,
        "value": item.city_code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needBankBranch == true),
      expression: "needBankBranch == true"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("开户支行 :")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "66.6%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请输入支行或12位银行联行号"
    },
    on: {
      "change": _vm.changeSubBranch
    },
    model: {
      value: (_vm.kaihuzhId),
      callback: function($$v) {
        _vm.kaihuzhId = $$v
      },
      expression: "kaihuzhId"
    }
  }, _vm._l((_vm.zhihangArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.bank_branch_name,
        "value": item.bank_branch_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入银行账号",
      "maxlength": "30",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.bankzh),
      callback: function($$v) {
        _vm.bankzh = $$v
      },
      expression: "bankzh"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("银行账号 :")])], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', {
    staticClass: "modtTitle"
  }, [_vm._v("资金管理员 "), _c('span', {
    staticClass: "zjgly"
  }, [_vm._v("(主要负责签约微信商户支付，并可接收日常重要管理信息和进行资金操作")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusId == 'FINISH'),
      expression: "statusId == 'FINISH'"
    }],
    staticClass: "xiugai",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.fundManager = true
      }
    }
  }, [_vm._v("修改")])], 1), _vm._v(" "), _c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("管理员类型 :")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.glylx),
      callback: function($$v) {
        _vm.glylx = $$v
      },
      expression: "glylx"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 65
    }
  }, [_vm._v("经营者/法人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 66
    }
  }, [_vm._v("经办人")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.glylx == 66),
      expression: "glylx == 66"
    }],
    staticClass: "rxgh"
  }, [_c('div', {
    staticClass: "rxghDiv"
  }, [(_vm.glyRxImgL) ? _c('el-image', {
    staticClass: "rxghAvatarImg",
    attrs: {
      "src": _vm.glyRxImgL,
      "preview-src-list": [_vm.glyRxImgL]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 4); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus rxghUploader"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit && _vm.glyRxImgL),
      expression: "isEdit && glyRxImgL"
    }],
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(4)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rxghSM"
  }, [_vm._v(" 管理员身份证正面（人像） ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rxghDiv"
  }, [(_vm.glyGhImgL) ? _c('el-image', {
    staticClass: "rxghAvatarImg",
    attrs: {
      "src": _vm.glyGhImgL,
      "preview-src-list": [_vm.glyGhImgL]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 5); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus rxghUploader"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit && _vm.glyGhImgL),
      expression: "isEdit && glyGhImgL"
    }],
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(5)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rxghSM"
  }, [_vm._v(" 管理员身份证反面（国徽） ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.glylx == 65),
      expression: "glylx == 65"
    }]
  }, [_c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入姓名",
      "maxlength": "10",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.glyNameOne),
      callback: function($$v) {
        _vm.glyNameOne = $$v
      },
      expression: "glyNameOne"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("管理员姓名 :")])], 2), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入18位身份证号码",
      "maxlength": "18",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.glySfzhmOne),
      callback: function($$v) {
        _vm.glySfzhmOne = $$v
      },
      expression: "glySfzhmOne"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("身份证号码 :")])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.glylx == 66),
      expression: "glylx == 66"
    }]
  }, [_c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入姓名",
      "maxlength": "10",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.glyNameTwo),
      callback: function($$v) {
        _vm.glyNameTwo = $$v
      },
      expression: "glyNameTwo"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("管理员姓名 :")])], 2), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请输入18位身份证号码",
      "maxlength": "18",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.glySfzhmTwo),
      callback: function($$v) {
        _vm.glySfzhmTwo = $$v
      },
      expression: "glySfzhmTwo"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("身份证号码 :")])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.glylx == 66),
      expression: "glylx == 66"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("有 效 期 限 : ")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "26%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" 至\r\n        "), _c('el-date-picker', {
    staticStyle: {
      "width": "26%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "disabled": !_vm.isEdit || _vm.yxqxThree
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.yxqxThree),
      callback: function($$v) {
        _vm.yxqxThree = $$v
      },
      expression: "yxqxThree"
    }
  }, [_vm._v("长期有效")])], 1), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "请填写常用邮箱（推荐网易邮箱和腾讯邮箱）",
      "maxlength": "25",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.glyEmail),
      callback: function($$v) {
        _vm.glyEmail = $$v
      },
      expression: "glyEmail"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("管理员邮箱 :")])], 2), _vm._v(" "), _c('el-input', {
    staticClass: "singleRow whiteDis",
    attrs: {
      "placeholder": "（用于接受微信支付的重要管理信息及日常操作验证码）",
      "maxlength": "11",
      "disabled": !_vm.isEdit
    },
    model: {
      value: (_vm.glyPhone),
      callback: function($$v) {
        _vm.glyPhone = $$v
      },
      expression: "glyPhone"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("管理员手机 :")])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.glylx == 66),
      expression: "glylx == 66"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "sqhPic"
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v("业务办理授权函 :")]), _vm._v(" "), (_vm.sqhLong) ? _c('el-image', {
    staticClass: "sqhImg",
    attrs: {
      "src": _vm.sqhLong,
      "preview-src-list": [_vm.sqhLong]
    },
    on: {
      "click": _vm.handleClickItem
    }
  }) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeIDcard(file, 6); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus sqhIcon"
  })]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit && _vm.sqhLong),
      expression: "isEdit && sqhLong"
    }],
    staticClass: "sqhDel",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delIDcard(6)
      }
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "ywblsqh"
  }, [_c('li', [_vm._v("提示：")]), _vm._v(" "), _c('li', [_vm._v("1、 扫描件或照片大小不得超过2M，所有材料均需清晰可见，不支持截图、翻拍、镜像照片；")]), _vm._v(" "), _c('li', [_vm._v("2、 授权函的信息全部需打印，除经营者签字外，其余不支持手写商户信息；")]), _vm._v(" "), _c('li', [_vm._v("3、 右下角单位名称和盖章日期请勿留空；")]), _vm._v(" "), _c('li', [_vm._v("4、 商户均应当在“单位（盖章）”处加盖主体公章鲜章，个体户应由经营者本人手写正楷签字并加盖手印。如个体户未刻制公章的，则以第5条规则为准；")]), _vm._v(" "), _c('li', [_vm._v("5、 个体户未刻制公章的，应在“经营者（签字捺印）”处，说明“无公章”并由经营者本人手写正楷签字及加盖手印；")]), _vm._v(" "), _c('li', [_vm._v("6、 业务办理授权函盖章有效期需为90天内。")]), _vm._v(" "), _c('li', [_vm._v("7、 点击这里“"), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.onYwblsqh
    }
  }, [_vm._v("业务办理授权函")]), _vm._v("”模板；")], 1)])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bbid),
      expression: "bbid"
    }],
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resultCodeFour == 4 || _vm.statusId == 'READDY' || _vm.statusId == null),
      expression: "resultCodeFour == 4 || statusId == 'READDY' || statusId == null"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.emit()
      }
    }
  }, [_vm._v("保存草稿")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ismark),
      expression: "ismark"
    }],
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.tjsh()
      }
    }
  }, [_vm._v(_vm._s(_vm.ismark ? '重新提交申请' : '提交申请'))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isinfo),
      expression: "isinfo"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.goChange()
      }
    }
  }, [_vm._v("变更信息")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择开户银行",
      "visible": _vm.bankofDeposit,
      "width": "35%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.bankofDeposit = $event
      },
      "closed": _vm.clearBank
    }
  }, [_c('el-input', {
    staticClass: "searchKhyh",
    attrs: {
      "placeholder": "请输入搜索内容"
    },
    model: {
      value: (_vm.inputKhyh),
      callback: function($$v) {
        _vm.inputKhyh = $$v
      },
      expression: "inputKhyh"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-container"
  }, [_vm._l((_vm.rmyhArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rmyhQuick"
    }, [_c('span', {
      class: _vm.currentIndex === index ? 'rmyhClass' : 'spanTitle',
      on: {
        "click": function($event) {
          return _vm.handleItem(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "radio-container",
    on: {
      "change": _vm.setBank
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, _vm._l((_vm.bankList), function(item, i) {
    return _c('el-dropdown-item', {
      key: i
    }, [_c('el-radio-button', {
      staticClass: "radioBtn",
      attrs: {
        "label": item.bank_alias_code
      }
    }, [_c('span', [_vm._v(_vm._s(item.bank_alias))])])], 1)
  }), 1)], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "打款信息",
      "visible": _vm.dkDialog,
      "width": "35%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dkDialog = $event
      },
      "closed": _vm.clearDkImg
    }
  }, [_c('ul', {
    staticClass: "dkClass"
  }, [_c('li', [_vm._v("付款用户："), _c('span', [_vm._v(_vm._s(_vm.accountValidation.account_name))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountValidation.account_no),
      expression: "accountValidation.account_no"
    }]
  }, [_vm._v("付款卡号："), _c('span', [_vm._v(_vm._s(_vm.accountValidation.account_no))])]), _vm._v(" "), _c('li', [_vm._v("汇款金额："), _c('span', [_vm._v(_vm._s(_vm.accountValidation.pay_amount))])]), _vm._v(" "), _c('li', [_vm._v("收款卡号："), _c('span', {
    staticClass: "dkColor"
  }, [_vm._v(_vm._s(_vm.accountValidation.destination_account_number))])]), _vm._v(" "), _c('li', [_vm._v("收款户名："), _c('span', {
    staticClass: "dkColor"
  }, [_vm._v(_vm._s(_vm.accountValidation.destination_account_name))])]), _vm._v(" "), _c('li', [_vm._v("开户银行："), _c('span', {
    staticClass: "dkColor"
  }, [_vm._v(_vm._s(_vm.accountValidation.destination_account_bank))])]), _vm._v(" "), _c('li', [_vm._v("省市信息："), _c('span', {
    staticClass: "dkColor"
  }, [_vm._v(_vm._s(_vm.accountValidation.city))])]), _vm._v(" "), _c('li', [_vm._v("备注信息："), _c('span', {
    staticClass: "dkColor"
  }, [_vm._v(_vm._s(_vm.accountValidation.remark))])]), _vm._v(" "), _c('li', [_vm._v("汇款截止时间："), _c('span', {
    staticClass: "dkColor"
  }, [_vm._v(_vm._s(_vm.accountValidation.deadline))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dkDialog = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改资金管理员",
      "visible": _vm.fundManager,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.fundManager = $event
      }
    }
  }, [_c('p', {
    staticClass: "zjglinfo"
  }, [_vm._v("请点击“去修改”按钮跳转到微信商户支付平台，使用现资金管理员微信扫一扫进行登录，登录成功后点击账户中心进行操作修改。（或浏览器输入https://pay.weixin.qq.com ）")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.fundManager = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makedes()
      }
    }
  }, [_vm._v("去修改")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "收款设置提示",
      "visible": _vm.sksztx,
      "width": "25%",
      "center": true
    },
    on: {
      "update:visible": function($event) {
        _vm.sksztx = $event
      },
      "close": function($event) {
        return _vm.cancelFun()
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("您的企业下还没有一家店铺，请先创建一个店铺后，再来设置收款信息。")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.goOpen()
      }
    }
  }, [_vm._v("去开店")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请选择企业",
      "visible": _vm.dialogSksz,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSksz = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "企业名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择企业"
    },
    on: {
      "change": _vm.handleChangeQymc
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-089bba17!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/financialManagement/collectionSettings.vue
// module id = 1631
// module chunks = 3